import { Button, Card, CardContent, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { theme } from "../../Assets/Theme/theme";
import { BASE_URL } from "../../Assets/Constants";
import axios from "axios";
import { toast } from "react-toastify";

function BookingsCard({ booking, refreshBookings }) {
  const handleCancelBooking = async () => {
    try {
      const bookingId = booking._id; 
      const response = await axios.get(`${BASE_URL}/user/booking/${bookingId}/canceled`);
      
      if (response.status === 200) {
        toast.success(response?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          style: { backgroundColor: 'orange', color: 'white' }, 
        });
        refreshBookings()
      } 
    } catch (error) {
      console.error("Error canceling booking:", error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  
  const getButtonStyles = (status) => {
    const isOutlined = status === "Pending" || status === "Timed out";
    if (status === "Cancel Booking") {
      return {
        backgroundColor: isOutlined ? "transparent" : "red",
        color: isOutlined ? "red" : "#fff",
        borderColor: "red",
      };
    } else if (status === "Completed") {
      return {
        backgroundColor: isOutlined ? "transparent" : "orange",
        color: isOutlined ? "orange" : "#fff",
        borderColor: "orange",
      };
    } else if (status === "Rejected") {
      return {
        backgroundColor: isOutlined ? "transparent" : "red",
        color: isOutlined ? "red" : "#fff",
        borderColor: "red",
      };
    } else if (status === "Cancelled") {
      return {
        backgroundColor: isOutlined ? "transparent" : "red",
        color: isOutlined ? "red" : "#fff",
        borderColor: "red",
      };
    } else if (status === "Timed out") {
      return {
        backgroundColor: isOutlined ? "transparent" : "green",
        color: isOutlined ? "green" : "#fff",
        borderColor: "green",
      };
    } else {
      return {};
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date.getFullYear()}/${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${date.getDate().toString().padStart(2, "0")}`;
  };

  const calculateParticipants = (ageCategories) => {
    return ageCategories.reduce((total, category) => total + category.count, 0);
  };

  return (
    <Card
      sx={{
        padding: 2,
        borderRadius: 2,
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
      }}
    >
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <Typography
              sx={{ fontWeight: "700", marginBottom: 1, fontSize: "16px" }}
              color={theme.colors.text}
            >
              Destination
            </Typography>
            <Typography color={theme.colors.text} fontWeight={"bold"}>
              {booking?.experienceId?.name}
              <br />
              {booking.location}
            </Typography>
          </Grid>
          <Grid item xs={12} md={2}>
            <Typography
              sx={{ fontWeight: "700", marginBottom: 1, fontSize: "16px" }}
              color={theme.colors.text}
            >
              Date
            </Typography>
            <Typography
              color={theme.colors.text}
              sx={{
                textDecoration: "underline",
                fontWeight: "400",
                fontSize: "16px",
              }}
            >
              {formatDate(booking.date)}
            </Typography>
          </Grid>
          <Grid item xs={12} md={2}>
            <Typography
              sx={{ fontWeight: "700", marginBottom: 1, fontSize: "16px" }}
              color={theme.colors.text}
            >
              No of Participants
            </Typography>
            <Typography
              color={theme.colors.text}
              sx={{
                fontWeight: "400",
                marginBottom: 1,
                fontSize: "16px",
              }}
            >
              {calculateParticipants(booking.ageCategories)}
            </Typography>
          </Grid>
          <Grid item xs={12} md={2}>
            <Typography
              sx={{ fontWeight: "700", marginBottom: 1, fontSize: "16px" }}
              color={theme.colors.text}
            >
              Total Price
            </Typography>
            <Typography
              color={theme.colors.text}
              sx={{
                fontWeight: "400",
                marginBottom: 1,
                fontSize: "16px",
              }}
            >
              {booking?.currency}
              {booking.total}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: 1, 
            }}
          >
            {booking?.paymentStatus !== "Cancelled" &&  <Button
              variant={
                booking.status === "Pending" || booking.status === "Timed out"
                  ? "outlined"
                  : "contained"
              }
              sx={{
                ...getButtonStyles(booking.status),
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor:
                    booking.status === "Pending" ||
                      booking.status === "Timed out"
                      ? getButtonStyles(booking.status).color + "20"
                      : getButtonStyles(booking.status).backgroundColor,
                },
              }}
            >
              {booking.status}
            </Button>}
            {booking.status === "Completed" && (
              <Button
              variant="contained"
              onClick={booking?.paymentStatus !== "Cancelled" ? handleCancelBooking : undefined}
              sx={{
                fontWeight: "bold",
                textTransform: "uppercase",
                backgroundColor:  "red",
                color: "#fff",
                "&:hover": {
                  backgroundColor: booking?.paymentStatus !== "Cancelled" && "red",
                },
              }}
            >
              {booking?.paymentStatus === "Cancelled" ? "Cancelled" : "Cancel Booking"}
            </Button>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default BookingsCard;
